/* eslint-disable import/no-unresolved */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import SearchFilterSocios from 'src/components/leads/searchFilterSocios';
import CampanasAdd from 'src/components/leads/campanas/CampanasAdd';
import CampanasAddCampaign from 'src/components/leads/campanas/CampanasAddCampaign';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CampanasDetails from 'src/components/leads/campanasDetails/CampanasDetails';
import { useStyles } from './styles';
import TableType4 from '@auteco/components/sharedComponents/Tablas/TableType4/TableType4';

const CampanasPage = (props) => {
  const classes = useStyles();

  const {
    form,
    isEdit,
    details,
    controls,
    ciudades,
    vehiculos,
    onOpenForm,
    openAddFormCampaign,
    onOpenFormCampaing,
    onCloseForm,
    onCloseFormCampaign,
    openDetails,
    permitValue,
    openAddForm,
    handleSubmit,
    handleChange,
    handleDelete,
    onOpenDetails,
    departamentos,
    filteredCities,
    onChangeInputs,
    onChangeInputsNew,
    campanas,
    establecimientos,
    establecimientosCampanasNew,
    controlComponent,
    handleChangeDepartment,
    selectedDateInit,
    selectedDateEnd,
    data
    
  } = props;

  const columnsLeads = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      hidden: true,
    },
    {
      title: 'NOMBRE CAMPAÑA',
      field: 'nombre_campana',
      editable: 'never',
    },
    {
      title: 'Fecha Inicial',
      field: 'fechaInicial',
      editable: 'never' 
    },
    {
      title: 'Fecha Final',
      field: 'fechaFinal',
      editable: 'never'
    },
    {
      title: 'Estado',
      field: 'estado',
      render: (rowData) => <td> {rowData.estado === "1" ? "Activo " : "Desactivado "}</td>
    },
    {
      title: 'Estado Global',
      field: 'estado_global',
      render: (rowData) => <td> {rowData.estado_global === "1" ? "Activo " : "Desactivado "}</td>
    }
  ];
  

  return (
    <>
      <CardTitle title="Campañas" />

      {openAddForm && (
        <CampanasAdd
          form={form}
          isEdit={isEdit}
          controls={controls}
          ciudades={ciudades}
          onClose={onCloseForm}
          vehiculos={vehiculos}
          establecimientos={establecimientos}
          handleSubmit={handleSubmit}
          openAddToSocio={openAddForm}
          onChangeInputs={onChangeInputs}
          selectedDateInit={selectedDateInit}
          selectedDateEnd={selectedDateEnd}
        />
      )}
      {permitValue >= 2 ? (
        <Button color="warning" onClick={onOpenForm} className={classes.button}>
          Agregar Campaña Especifica
        </Button>
      ) : null}


      {/*onOpenFormCampaing && (
        <CampanasAddCampaign
          form={form}
          isEdit={isEdit}
          controls={controls}
          ciudades={ciudades}
          onClose={onCloseFormCampaign}
          vehiculos={vehiculos}
          establecimientosCampanasNew={establecimientosCampanasNew}
          handleSubmit={handleSubmit}
          openAddToSocio={openAddFormCampaign}
          onChangeInputs={onChangeInputs}
          selectedDateInit={selectedDateInit}
          selectedDateEnd={selectedDateEnd}
          onChangeInputsNew={onChangeInputsNew}
          data={data}
        />
      ) */}
      { /*permitValue >= 2 ? (
        <Button color="warning" onClick={onOpenFormCampaing} className={classes.button}>
          Agregar Campaña 2
        </Button>
      ) : null */}

     {/* <SearchFilterSocios
        lineas={vehiculos}
        ciudades={filteredCities}
        handleChange={handleChange}
        departamentos={departamentos}
        controlComponent={controlComponent}
        handleChangeDepartment={handleChangeDepartment}
      />*/}

      <TableType4
        hiddenDelete={permitValue < 4}
        hiddenEdit={permitValue < 3}
        onOpenDetails={onOpenDetails}
        pageSize={10}
        columns={columnsLeads}
        openForm={onOpenForm}
        onDelete={handleDelete}
        title="Campañas"
        dataTable={campanas}
      />

      <CampanasDetails
        details={details}
        onClose={onCloseForm}
        openDetails={openDetails}
      />
    </>
  );
};

export default CampanasPage;
